var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM15.2034 9.28937C15.2479 9.31535 15.2848 9.35269 15.3103 9.39758C15.3357 9.44246 15.3488 9.49328 15.3482 9.54487C15.3476 9.59645 15.3333 9.64695 15.3068 9.69121L10.737 17.8309C10.702 17.8862 10.6494 17.9282 10.5878 17.9502C10.5261 17.9722 10.4589 17.9729 10.3967 17.9523C10.3346 17.9316 10.2811 17.8908 10.2449 17.8363C10.2086 17.7818 10.1916 17.7167 10.1966 17.6515L10.7043 12.7497H6.94053C6.88865 12.7497 6.83772 12.7359 6.79297 12.7096C6.74822 12.6833 6.71129 12.6456 6.68598 12.6003C6.66066 12.5551 6.64789 12.5038 6.64896 12.452C6.65004 12.4001 6.66493 12.3495 6.69211 12.3053L11.3386 4.16471C11.3746 4.10951 11.428 4.068 11.4904 4.04687C11.5528 4.02574 11.6205 4.02621 11.6825 4.04822C11.7446 4.07023 11.7975 4.11249 11.8326 4.1682C11.8678 4.2239 11.8831 4.28981 11.8763 4.35532L11.2357 9.2497H15.0565C15.1081 9.2497 15.1588 9.26339 15.2034 9.28937Z",
    fill: "#FAAD14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.39f3c22c0abe9972845d3e75d5ae5ea0.svg";
export { ForwardRef as ReactComponent };